<app-side-nav pageDetails="accessibility" [parentComponent]="this"></app-side-nav>
<app-rating></app-rating>
<app-footer></app-footer>